export default function UserViewer({ value }) {
  return <span>{value.label}</span>
}

UserViewer.isViewerFor = (x) => x.kind === "User"
